import React from 'react';
import PropTypes from 'prop-types';
import ProgramType from '../../../../components/program-type';

function GroupRowInnerRenderer(props) {
  const v = props.value;
  const { node: { field }, context: { clients, programs } } = props;
  
  const isClient = field === 'client_id';
  const isPrentObject = field === 'parent';

  if (isPrentObject) {
    return (
      <span>Object: <strong className="text-uppercase"><code>{v}</code></strong></span>
    );
  }

  if (isClient) {
    return (
      <span>Client: <strong>{clients[v]}</strong></span>
    );
  }
  return (
    <span><ProgramType type={programs[v].type} /><strong>{programs[v].name}</strong></span>
  );
}
GroupRowInnerRenderer.propTypes = {
  valueFormatted: PropTypes.string,
  value: PropTypes.string.isRequired,
  node: PropTypes.shape({
    field: PropTypes.string.isRequired,
  }).isRequired,
  context: PropTypes.shape({
    clients: PropTypes.shape({}).isRequired,
    programs: PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.string,
      type_value: PropTypes.string,
    }).isRequired,
  }).isRequired,
};
export default GroupRowInnerRenderer;
